import React from 'react';
import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initOfflineShell } from './utils/serviceWorker';

dayjs.extend(utc);
dayjs.extend(timezone);

// Arranque sin red: solo registra algo en la PC de la caja (la del Print Agent).
initOfflineShell();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
